import { useCallback } from 'react';
import useSessionStorage from '../../../../hooks/useSessionStorage';
import { debounce } from 'lodash';

export default function useSessionStorageProject(debounceTime = 1000) {
	const [source, setSource, resetSource] = useSessionStorage<
		string | undefined
	>('projectSourceId', undefined);

	const debounceResetSource = useCallback(
		debounce(() => resetSource(), debounceTime),
		[resetSource],
	);

	return {
		source,
		setSource,
		resetSource,
		debounceResetSource,
	};
}
